if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          // --- BEGIN: Wire up option selector to update hidden input with correct variant ID ---
          const productFormEl = this.modalContent.querySelector('product-form');
          console.log('productFormEl:', productFormEl);
          const variantForm = productFormEl ? productFormEl.querySelector('form') : null;
          console.log('variantForm:', variantForm);
          if (variantForm) {
            // Find the variants JSON (the first <script type="application/json"> inside the modal)
            const variantsScript = this.modalContent.querySelector('script[type="application/json"]');
            console.log('variantsScript:', variantsScript);
            if (variantsScript) {
              const variants = JSON.parse(variantsScript.textContent);
              // Find all option selects (e.g., Flavor) ANYWHERE in the modal
              const optionSelects = this.modalContent.querySelectorAll('select[name^="options["]');
              const idInput = variantForm.querySelector('input[name="id"]');
              console.log('optionSelects:', optionSelects, 'idInput:', idInput);
              if (optionSelects.length && idInput) {
                optionSelects.forEach(select => {
                  select.addEventListener('change', function() {
                    const selectedOptions = Array.from(optionSelects).map(s => s.value);
                    const matchedVariant = variants.find(v => {
                      return selectedOptions.every((opt, idx) => v[`option${idx+1}`] === opt);
                    });
                    if (matchedVariant) {
                      idInput.value = matchedVariant.id;
                      idInput.disabled = false; // Ensure it's enabled
                      console.log('Updated variant id:', matchedVariant.id);
                    } else {
                      console.log('No matching variant found for options:', selectedOptions);
                    }
                  });
                });
              }
            }
          }
          // --- END: Wire up option selector to update hidden input with correct variant ID ---



          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        
        const scriptContent = oldScriptTag.innerHTML;
        
        // Only wrap executable JavaScript with try-catch, not JSON data
        if (oldScriptTag.type === 'application/json' || oldScriptTag.type === 'application/ld+json') {
          // For JSON scripts, just copy the content as-is
          newScriptTag.appendChild(document.createTextNode(scriptContent));

        } else {
          // For other executable scripts, wrap in try-catch to handle variable redeclaration errors
          const wrappedContent = `
            try {
              ${scriptContent}
            } catch (e) {
              // Ignore redeclaration errors but log other errors
              if (!e.message.includes('already been declared') && !e.message.includes('Identifier') && !e.message.includes('has already been declared')) {
                console.error('Script execution error:', e);
              }
            }
          `;
          newScriptTag.appendChild(document.createTextNode(wrappedContent));
        }
        
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
      

    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }









  });
}
